import { render, staticRenderFns } from "./SignatureStats.vue?vue&type=template&id=43dc81aa&scoped=true"
import script from "./SignatureStats.vue?vue&type=script&lang=js"
export * from "./SignatureStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc81aa",
  null
  
)

export default component.exports